"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SampoLinkBlock = void 0;
const react_1 = __importDefault(require("react"));
const Link_1 = __importStar(require("../Common/Link"));
const SampoLinkBlock = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    let renderAsList;
    if (typeof (props.parentVar) === 'object') {
        try {
            renderAsList = props.parentVar;
        }
        catch (_q) { }
    }
    const target = props.data.linkTarget.value === '_blank' ? Link_1.LinkTarget.New_window : Link_1.LinkTarget.Current_window;
    const type = Link_1.LinkType[props.data.linkType.value];
    let cssClasses = renderAsList && renderAsList.renderAsListElement ?
        ['d-flex', 'flex-column', 'justify-content-center', (_a = props.data.bottomMargin) === null || _a === void 0 ? void 0 : _a.value, (_b = props.data.topMargin) === null || _b === void 0 ? void 0 : _b.value] : [(_c = props.data.bottomMargin) === null || _c === void 0 ? void 0 : _c.value, (_d = props.data.topMargin) === null || _d === void 0 ? void 0 : _d.value];
    let href = props.data.href.value;
    if (!type || (!href && ((_e = props.data.documentLinks) === null || _e === void 0 ? void 0 : _e.value.length) < 1))
        return null;
    const equalsizableTypes = [Link_1.LinkType.Icon_link, Link_1.LinkType.Icon_link_between, Link_1.LinkType.Icon_link_with_underline];
    const additionalCssClasses = [];
    if (renderAsList && renderAsList.renderAsListElement && equalsizableTypes.includes(type)) {
        additionalCssClasses.push('h-100');
        if ((_f = props.data.showBorder) === null || _f === void 0 ? void 0 : _f.value) {
            additionalCssClasses.push(props.data.showBorder.value);
            additionalCssClasses.push('pb-6');
        }
    }
    const link = react_1.default.createElement(Link_1.default, { documents: props.data.documentLinks.value, href: href, target: target, title: props.data.linkTitle.value, type: type, icon_class: props.data.iconClass.value, icon_front: props.data.iconPosition.value === 'start' ? true : false, download: (_g = props.data.useAsDownload) === null || _g === void 0 ? void 0 : _g.value, lineHeight: (_h = props.data.titleHeight) === null || _h === void 0 ? void 0 : _h.value, documentType: (_j = props.data.documentType) === null || _j === void 0 ? void 0 : _j.value, additionalCssClasses: additionalCssClasses, blockLang: props.data.blockLanguage.value, ariaLabel: (_k = props.data.linkAriaLabel) === null || _k === void 0 ? void 0 : _k.value });
    if (renderAsList && renderAsList.renderAsListElement) {
        return react_1.default.createElement("li", { className: `${(renderAsList === null || renderAsList === void 0 ? void 0 : renderAsList.listItemClass) || props.displayOptionClasses} ${cssClasses.join(' ')}` },
            link,
            ((_l = props.data.showBorder) === null || _l === void 0 ? void 0 : _l.value) && type !== Link_1.LinkType.Icon_link_between &&
                react_1.default.createElement("div", { className: `${(_m = props.data.showBorder) === null || _m === void 0 ? void 0 : _m.value} pt-6` }));
    }
    if (props.data.useButtonInContentArea) {
        return react_1.default.createElement("div", { className: `sampolinkblock ${cssClasses.join(' ')}` },
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: 'col-12' }, link)),
            ((_o = props.data.showBorder) === null || _o === void 0 ? void 0 : _o.value) &&
                react_1.default.createElement("div", { className: 'row' },
                    react_1.default.createElement("div", { className: 'col-12 pt-6' },
                        react_1.default.createElement("div", { className: (_p = props.data.showBorder) === null || _p === void 0 ? void 0 : _p.value }))));
    }
    return link;
};
exports.SampoLinkBlock = SampoLinkBlock;
exports.default = exports.SampoLinkBlock;
